export default __webpack_public_path__ + "static/media/work_in_progress_uhmv.d3bc3235.svg";